/**
 * Mobile nav JS
 */

document.addEventListener("DOMContentLoaded", function () {
  const menuToggle = document.querySelector(".menu-toggle");
  const mobileNavContainer = document.querySelector(".mobile-nav");

  // Return if either of the elements isn't present.
  if (!menuToggle || !mobileNavContainer) return;

  menuToggle.addEventListener("click", () => {
    const expanded =
      menuToggle.getAttribute("aria-expanded") === "true" || false;

    document.body.classList.toggle("menu-open");

    menuToggle.setAttribute("aria-expanded", !expanded);
    mobileNavContainer.hidden = !mobileNavContainer.hidden;
    menuToggle.classList.toggle("menu-toggle--open");
    mobileNavContainer.classList.toggle("mobile-nav--open");
  });

  // Nav Item toggling.
  document.querySelectorAll('.menu-item-has-children').forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
      if (window.innerWidth <= 768) {
        e.preventDefault();
        const parent = toggle.parentElement;
        parent.classList.toggle('open');
      }
    });
  });

  // function initSubmenuLinks() {
  document.querySelectorAll('.menu-item-has-children .sub-menu li a').forEach(link => {
    link.addEventListener('click', function () {
      document.body.classList.remove("menu-open");
      menuToggle.setAttribute("aria-expanded", false);
      mobileNavContainer.hidden = true;
      menuToggle.classList.remove("menu-toggle--open");
      mobileNavContainer.classList.remove("mobile-nav--open");
    });
  });
  // }

});
